import cn from "clsx";
import { TextLink } from "@crehana/ui";
import { useLearningPlanTranslation } from "../hooks/useLearningPlanTranslation";
import ProgressBarDetailed from "../ui/ProgressBarDetailed";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var getStatus = function getStatus(progress, currentDayIndex) {
  if (!progress) {
    return currentDayIndex >= 2 ? 'ACTIVITY_EMPTY_3_DAYS_LABEL' : 'ACTIVITY_EMPTY_LABEL';
  }
  if (progress >= 100) {
    return progress > 100 ? 'ACTIVITY_EXCEDED_LABEL' : 'ACTIVITY_COMPLETED_LABEL';
  }
  return progress >= 75 ? 'ACTIVITY_ALMOST_COMPLETED_LABEL' : 'ACTIVITY_IN_PROGRESS_LABEL';
};
var ActivityMetrics = function ActivityMetrics(_ref) {
  var isDark = _ref.isDark,
    isCompact = _ref.isCompact,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    targetMins = _ref.target.minutes,
    progress = _ref.progress,
    onEditStudyPlan = _ref.onEditStudyPlan,
    currentDayIndex = _ref.currentDayIndex;
  var _useLearningPlanTrans = useLearningPlanTranslation(),
    t = _useLearningPlanTrans.t;
  var activityStatus = getStatus(progress.percent, currentDayIndex);
  var isVertical = orientation === 'vertical';
  var shouldRenderEditStudyPlan = !progress && currentDayIndex >= 2;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('w-full h-full flex flex-col rounded-10 p-12', isDark ? 'bg-gray-main-dark-mode text-white' : 'bg-white text-base-dark shadow-1-dp'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex justify-between items-center mb-12",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "font-subtitle3",
        children: t('ACTIVITY_TITLE')
      }), !!(progress !== null && progress !== void 0 && progress.percent) && /*#__PURE__*/_jsx(TextLink, {
        className: "hidden sm:inline-flex ml-16",
        label: t('EDIT_STUDY_PLAN'),
        type: "level2",
        onClick: onEditStudyPlan
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cn('flex items-center sm:items-start sm:text-left', isCompact && isVertical ? 'flex-col-reverse' : 'flex-col'),
      children: shouldRenderEditStudyPlan ? /*#__PURE__*/_jsxs("p", {
        className: "font-subtitle4 text-gray-dark",
        children: [t('CHANGE_WEEKLY_TARGET', {
          interpolation: {
            minutes: targetMins
          }
        }), /*#__PURE__*/_jsx(TextLink, {
          label: t('CHANGE_WEEKLY_TARGET_CTA'),
          onClick: onEditStudyPlan
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          className: cn('font-body4', isCompact && isVertical ? 'mt-16' : 'mb-12'),
          children: t(activityStatus)
        }), /*#__PURE__*/_jsx(ProgressBarDetailed, {
          isDark: isDark,
          progress: progress.percent > 100 ? 100 : progress.percent,
          label: t('MINUTE_COUNT', {
            interpolation: {
              progress: progress.minutes,
              total: targetMins
            }
          })
        })]
      })
    })]
  });
};
export default ActivityMetrics;